// Minimum password length
const PASSWORD_LENGTH = 7;
/** Password policy
 * Minimum length is 7
 * Must contain at least 3 character sets (lowercase, capitals, numbers, punctuation)
 */

// Checks if new password meets password policy
/**
 * Checks if new password meets password policy
 * @param password
 * @returns true if password conforms to policy
 */
export function passwordAcceptable(password: string): boolean {
	switch (true) {
		case password.length < PASSWORD_LENGTH: {
			return false;
		}
		case !containsThreeCharacterTypes(password): {
			return false;
		}
	}
	return true;
}

export function isAcceptableLength(password: string): boolean {
	return password.length >= PASSWORD_LENGTH;
}

export function containsLowerCase(password: string): boolean {
	if (new RegExp(/.*[a-z].*/).test(password)) {
		return true;
	}
	return false;
}

export function containsUpperCase(password: string): boolean {
	if (new RegExp(/.*[A-Z].*/).test(password)) {
		return true;
	}
	return false;
}

export function containsNumber(password: string): boolean {
	if (new RegExp(/.*[0-9].*/).test(password)) {
		return true;
	}
	return false;
}

export function containsSymbol(password: string): boolean {
	if (new RegExp(/[^a-zA-Z0-9]/).test(password)) {
		return true;
	}
	return false;
}
/**
 * Checks if password contains a minimum of three character types
 * @param password
 * @returns true if it contains at least 3 char sets
 */
export function containsThreeCharacterTypes(password: string): boolean {
	let nCharacterTypes = 0;
	if (containsLowerCase(password)) {
		nCharacterTypes += 1;
	}
	if (containsUpperCase(password)) {
		nCharacterTypes += 1;
	}
	if (containsNumber(password)) {
		nCharacterTypes += 1;
	}
	if (containsSymbol(password)) {
		nCharacterTypes += 1;
	}
	if (nCharacterTypes >= 3) {
		return true;
	}
	return false;
}

export function calculateCharSets(password: string): number {
	let nCharacterTypes = 0;
	if (containsLowerCase(password)) {
		nCharacterTypes += 1;
	}
	if (containsUpperCase(password)) {
		nCharacterTypes += 1;
	}
	if (containsNumber(password)) {
		nCharacterTypes += 1;
	}
	if (containsSymbol(password)) {
		nCharacterTypes += 1;
	}
	return nCharacterTypes;
}

/**
 * Checks if the new passwords match
 * @param password1
 * @param password2
 * @returns true if the two passwords match
 */
export function passwordsMatch(password1: string, password2: string): boolean {
	return password1 === password2 && passwordAcceptable(password1);
}

/**
 * Returns the initials
 * @param firstName
 * @param lastName
 * @returns initials
 */
export function getInitials(firstName: string, lastName: string): string {
	return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
}

/**
 * Checks if email is valid
 * @param email
 * @returns true if valid
 */
export const isValidEmail = (email: string): boolean => {
	const regexp = new RegExp(
		[
			'^(([^<>()[\\]\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\.,;:\\s@"]+)*)',
			'|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.',
			"[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+",
			"[a-zA-Z]{2,}))$",
		].join(""),
	);
	return regexp.test(email);
};

/**
 * Checks if name is valid
 * @param name
 * @returns
 */
export const isValidName = (name: string): boolean => {
	const regexp = new RegExp("/^[a-z ,.'-]+$/i");
	return regexp.test(name);
};
